import { Student } from '@/services/bridge/types/bridge.types'

// Mock fixture for new-host scenario：每筆都有 serialNumber，含一筆「未進教室」（studentId: null）
// 以及一筆「模擬舊版 Windows host」（serialNumber: null）以同時覆蓋兩條相容路徑。
export const MOCK_STUDENTS: Student[] = [
  { serialNumber: 1, studentId: '1', name: '漩渦鳴人', seatNumber: '1' },
  { serialNumber: 2, studentId: '2', name: '宇智波佐助', seatNumber: '2' },
  { serialNumber: 3, studentId: '3', name: '春野櫻', seatNumber: '3' },
  { serialNumber: 4, studentId: '4', name: '旗木卡卡西', seatNumber: '4' },
  { serialNumber: 5, studentId: '5', name: '路飛', seatNumber: '5' },
  { serialNumber: 6, studentId: '6', name: '索隆', seatNumber: '6' },
  { serialNumber: 7, studentId: '7', name: '娜美', seatNumber: '7' },
  { serialNumber: 8, studentId: '8', name: '香吉士', seatNumber: '8' },
  { serialNumber: 9, studentId: '9', name: '蒙其·D·魯夫', seatNumber: '9' },
  { serialNumber: 10, studentId: '10', name: '喬巴', seatNumber: '10' },
  { serialNumber: 11, studentId: '11', name: '艾斯', seatNumber: '11' },
  { serialNumber: 12, studentId: '12', name: '黑崎一護', seatNumber: '12' },
  { serialNumber: 13, studentId: '13', name: '朽木露琪亞', seatNumber: '13' },
  { serialNumber: 14, studentId: '14', name: '日番谷冬獅郎', seatNumber: '14' },
  { serialNumber: 15, studentId: '15', name: '夜神月', seatNumber: '15' },
  { serialNumber: 16, studentId: '16', name: 'L', seatNumber: '16' },
  {
    serialNumber: 17,
    studentId: '17',
    name: '愛德華·艾力克',
    seatNumber: '17',
  },
  {
    serialNumber: 18,
    studentId: '18',
    name: '阿爾馮斯·艾力克',
    seatNumber: '18',
  },
  // 未進教室（新版 host 才會出現）：studentId 為 null，但 serialNumber 必填
  { serialNumber: 19, studentId: null, name: '尚未報到 A', seatNumber: null },
  { serialNumber: 20, studentId: null, name: '尚未報到 B', seatNumber: null },
  // 模擬舊版 Windows host：無 serialNumber，但 studentId 一定有
  {
    serialNumber: null,
    studentId: 'legacy-1',
    name: '舊版 host 學生',
    seatNumber: '21',
  },
  // 姓名縮寫測資（轉盤標籤會自動縮寫，原始 name 不變）
  { serialNumber: 22, studentId: '22', name: 'Fred Lin', seatNumber: '22' },
  { serialNumber: 23, studentId: '23', name: 'Fred', seatNumber: '23' },
  { serialNumber: 24, studentId: '24', name: 'fred lin', seatNumber: '24' },
  { serialNumber: 25, studentId: '25', name: 'dog cat', seatNumber: '25' },
  { serialNumber: 26, studentId: '26', name: '王 Fred', seatNumber: '26' },
  // 含 middle initial（單字母）：first name 原樣、J 單字母 → 不加點不緊接、
  // Lee 多字母 → 加點；因 J 不加點故與 Lee 之間仍留空格 => Amy J L.
  { serialNumber: 27, studentId: '27', name: 'Amy J Lee', seatNumber: '27' },
  // AC2 / AC6：3 個 token 全多字母 Latin，Michael 與 Lin 都加點 → 緊接 => John M.L.
  {
    serialNumber: 28,
    studentId: '28',
    name: 'John Michael Lin',
    seatNumber: '28',
  },
  // AC7：中文開頭 + 多個 Latin，非首位的兩個 Latin 都加點 → 緊接 => 林 O.L.
  { serialNumber: 29, studentId: '29', name: '林 Olivia Lin', seatNumber: '29' },
  // 帶變音的 Latin（Unicode Script=Latin 判定，NFC 正規化）=> José G.
  {
    serialNumber: 30,
    studentId: '30',
    name: 'José García',
    seatNumber: '30',
  },
]
